import { get, put, post } from "./api";

const controller = 'InteractEnvironment';

// The status provider and the environments page ask for the same data on start-up; callers that
// overlap share one request instead of each waiting on the slow endpoint.
const inFlight = new Map();
const shared = (key, request) => {
  if (!inFlight.has(key)) {
    inFlight.set(key, request().finally(() => inFlight.delete(key)));
  }
  return inFlight.get(key);
}

// includeVirtual=false leaves out groups served by another endpoint; fetch those with getAllFromEvironmentGroup.
export const getAll = ({ includeVirtual = true } = {}) =>
  includeVirtual
    ? shared('all', () => get(`api/${controller}/all`))
    : shared('all-local', () => get(`api/${controller}/all?includeVirtual=false`));

export const getAllFromEvironmentGroup = (environmentGroupId) =>
  shared(`group-${environmentGroupId}`, () => get(`api/${controller}/all/${environmentGroupId}`));

export const getUnusedEvironments = async (environmentGroupId) => {
  return await get(`api/${controller}/environments/unused/${environmentGroupId}`);
}

export const updateEnvironment = async (templateId, values) => {
  return await put(`api/${controller}/${templateId}`, values);
}

export const createEnvironment = async (values) => {
  return await post(`api/${controller}`, values);
}

export const updateEnvironmentOrder = async (values) => {
  return await put(`api/${controller}/order`, values);
}

export const deleteEnvironment = async (values) => {
  return await post(`api/${controller}/delete`, values);
}
